<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Add Payout</h3>
        <h4>2/4</h4>
      </div>
      <div class="row d-flex justify-content-center">
        <form class="col-xl-6" [formGroup]="form">
          <div class="my-4">
            <label for="payoutFrequency" class="form-label"
              >Payout Frequency <span class="text-danger">*</span></label
            >
            <select class="form-select" id="payoutFrequency" formControlName="payoutFrequency">
              <option selected disabled value="">Select Payout Frequency</option>
              <option *ngFor="let val of payoutFrequencyValues" [ngValue]="val">
                {{ formatEnumValues(val) }}
              </option>
            </select>
          </div>
          <div class="my-4">
            <label for="currency" class="form-label"
              >Currency <span class="text-danger">*</span></label
            >
            <select class="form-select" id="currency" formControlName="currency">
              <option selected value="">Select Currency</option>
              <option *ngFor="let country of countries$ | async" [ngValue]="country.currency">
                {{ country.currency_name }}
              </option>
            </select>
          </div>
          <div class="my-4">
            <label for="ctc" class="form-label">CTC <span class="text-danger">*</span></label>
            <input
              appTrimInput
              type="text"
              class="form-control"
              formControlName="ctc"
              autocomplete="off"
              appIndianNumberInputFormat
            />
            <div *ngIf="form.get('ctc')?.errors?.['required']">
              <span class="text-danger">
                {{ getErrorMessage('ctc') }}
              </span>
            </div>
          </div>
          <div class="my-4">
            <label for="basis" class="form-label">Basis <span class="text-danger">*</span></label>
            <select class="form-select" id="basis" formControlName="basis">
              <option selected value="">Select Basis</option>
              <option *ngFor="let val of basisValues" [ngValue]="val">
                {{ formatEnumValues(val) }}
              </option>
            </select>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
